import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import { Grid, Box, Button, Chip, InputLabel } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
// import { Card, CardContent, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import _uniqueId from "lodash/uniqueId";
import { countries, getStateList } from "../constants/dropdown";
import URLS from "../constants/URL";
import LargeImageUrl from "../images/desktop.png";
import MobileImageUrl from "../images/mobile.png";
import "./EasyApplyForm.css";
import ComboSelectBox from "./ComboSelectBox";
import SimpleUploadLink from "./SimpleUploadLink";
import { prepareSaveData } from "./PrepareData";
import { requestAPI } from "./serviceUtil";
import CustomizedSnackbar from "./Snackbar";
import Loader from "./Loader";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const styles = {
  lgImage: {
    width: "100%",
    height: "100%",
  },
  mobileImage: {
    width: "100%",
    height: "100%",
  },
  formStyle: {
    marginTop: 75,
    padding: "0 10%",
  },
  mobileForm: {
    marginTop: 0,
    padding: "5%",
  },
  bgDescription: {
    backgroundColor: "#F4F7FC",
    width: "100%",
    height: "100vh",
  },
  labelText: {
    color: "#656565",
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 16,
  },
  textFieldBg: {
    backgroundColor: "#F4F7FC",
  },
  outlinedBorder: {
    fontFamily: `"Open Sans", sans-serif`,
    background: "#F4F7FC",
    borderRadius: 7,
  },
};

const validation = (regex, value) => {
  if (value === "" || regex.test(value.trim())) {
    return true;
  }
  return false;
};
const stringValidation = (value) => {
  return validation(/^[ a-zA-Z]+$/, value);
};
const numberValidation = (value) => {
  return validation(/^[0-9]{1,10}$/g, value);
};
const cityValidation = (value) => {
  return validation(/^[ A-Za-z-,.']+$/, value);
};
const zipValidation = (value) => {
  return validation(/^[ A-Za-z0-9]{1,8}$/g, value);
};
const checkLength = (value) => {
  return !value ? true : (value + "").length >= 5 && (value + "").length <= 8;
};

const EasyApplyForm = (props) => {
  const [state, setState] = useState({
    initialValue: {
      fullName: "",
      email: "",
      phone: "",
      country: "",
      state: "",
      city: "",
      zip: "",
      candidate_resume: [],
      requisitionNumber: "",
      positionTitle: "",
      action: "SUBMIT",
    },
    isShowLoading: false,
    stateName: "",
    file: "",
    resumeValidation: false,
  });
  // const [isAppliedSuccess, setIsAppliedSuccess] = useState(false);
  const [showSnack, setShowSnack] = useState({});
  const showSnackMessage = (type, message) => {
    const id = _uniqueId("prefix-");
    const obj = {
      type,
      message,
      snackOpen: id,
    };
    setShowSnack(obj);
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().required(" "),
    email: Yup.string().email("Enter a valid email").required(" "),
    phone: Yup.string()
      .required(" ")
      .length(10, "Phone number must be 10 digit"),
    country: Yup.string().required(" "),
    state: Yup.string().required(" "),
    city: Yup.string().required(" "),
    zip: Yup.string()
      .required(" ")
      .test("len", "Zip must be 5-8 characters", (value) => checkLength(value)),
  });

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let qrid = params.rid;
  let qjt = params.jt;

  const saveApplication = async (data) => {
    setState({
      ...state,
      isShowLoading: true,
    });
    data.candidate_resume = state.file;
    data.requisitionNumber = qrid === null || qrid === undefined ? "" : qrid;
    data.positionTitle = qjt === null || qjt === undefined ? "" : qjt;
    const formData = prepareSaveData(data);
    const response = await requestAPI(
      URLS.createCandidate,
      formData,
      "POST",
      "createCandidate"
    );
    if (response.message === "SUCCESS - SUBMIT") {
      setState({
        ...state,
        isShowLoading: false,
      });
      // setIsAppliedSuccess(true);
      window.open("https://www.ptechpartners.com/thank-you-g/", "_self");
    } else {
      setState({
        ...state,
        isShowLoading: false,
      });
      showSnackMessage("error", "Something went wrong. Please try again.");
    }
  };
  const uploadResume = async (target) => {
    const { files } = target;
    const formData = new FormData();
    formData.append("file", files[0]);
    const response = await requestAPI(
      URLS.uploadResume,
      formData,
      "POST",
      "uploadFile"
    );
    if (response.message === "SUCCESS") {
      setState((prevState) => ({
        ...prevState,
        isShowLoading: false,
      }));
      showSnackMessage("success", "File uploaded successfully!");
    } else {
      setState((prevState) => ({
        ...prevState,
        isShowLoading: false,
      }));
      showSnackMessage("error", "Something went wrong. Please try again.");
    }
  };
  const handleFileUpload = ({ target }) => {
    const { name, files } = target;
    if (name === "candidate_resume") {
      uploadResume(target);
    }
    var fileList = [];
    for (var i = 0; i < files.length; i++) {
      fileList.push(files[i]);
    }
    setState({
      ...state,
      file: fileList,
      isShowLoading: true,
    });
  };
  function getStateListAll(state) {
    const stateList = getStateList(state);
    setState({
      ...state,
      initialValue: {
        state: "",
      },
      stateName: stateList,
    });
  }
  const isMobileDevice = useMediaQuery("(max-width:599px)");
  const isTabletOrLaptopDevice = useMediaQuery("(min-width:600px)");
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={3}
        style={{
          height: isTabletOrLaptopDevice ? "100vh" : "auto",
          display: isTabletOrLaptopDevice ? "flex" : "block",
        }}
      >
        <Box
          component="img"
          style={isTabletOrLaptopDevice ? styles.lgImage : styles.mobileImage}
          alt="Easy Apply User Interface"
          src={isTabletOrLaptopDevice ? LargeImageUrl : MobileImageUrl}
        />
      </Grid>
      {isMobileDevice && (
        <Grid item xs={12}>
          <div style={{ backgroundColor: "#F4F7FC" }}>
            <div style={{ padding: "5%" }}>
              <p style={{ fontSize: 18, fontWeight: "bold", marginTop: 0 }}>
                Requisition Details
              </p>
              <p>
                <b>Requisition Number:</b> {qrid}
              </p>
              <p style={{ marginBottom: 0 }}>
                <b>Position Title:</b> {qjt}
              </p>
            </div>
          </div>
        </Grid>
      )}
      <Grid item sm={9}>
        {/* {!isAppliedSuccess ? ( */}
          <Formik
            initialValues={state.initialValue}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              state.file
                ? saveApplication(values)
                : setState({ ...state, resumeValidation: true });
            }}
          >
            {({ errors, touched, handleSubmit, handleChange, values }) => (
              <>
                <form id="easy-apply-form" onSubmit={handleSubmit}>
                  {state.isShowLoading && <Loader />}
                  <Grid container>
                    <Grid item sm={7}>
                      <div
                        style={
                          isTabletOrLaptopDevice
                            ? styles.formStyle
                            : styles.mobileForm
                        }
                      >
                        <Grid item sm={12}>
                          <InputLabel
                            htmlFor="fullName"
                            style={styles.labelText}
                          >
                            Full Name
                          </InputLabel>
                          <TextField
                            id="fullName"
                            name="fullName"
                            variant="outlined"
                            value={values.fullName}
                            onChange={(e) => {
                              e.preventDefault();
                              if (stringValidation(e.target.value))
                                handleChange(e);
                            }}
                            inputProps={{
                              style: {
                                padding: "3px 14px",
                                height: 40,
                              },
                            }}
                            helperText={touched.fullName ? errors.fullName : ""}
                            error={touched.fullName && Boolean(errors.fullName)}
                            margin="dense"
                            fullWidth
                            style={styles.textFieldBg}
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <InputLabel htmlFor="email" style={styles.labelText}>
                            Email
                          </InputLabel>
                          <TextField
                            id="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            variant="outlined"
                            inputProps={{
                              style: {
                                padding: "3px 14px",
                                height: 40,
                              },
                            }}
                            helperText={touched.email ? errors.email : ""}
                            error={touched.email && Boolean(errors.email)}
                            margin="dense"
                            fullWidth
                            style={styles.textFieldBg}
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <InputLabel htmlFor="phone" style={styles.labelText}>
                            Phone Number
                          </InputLabel>
                          <TextField
                            id="phone"
                            name="phone"
                            variant="outlined"
                            value={values.phone}
                            onChange={(e) => {
                              e.preventDefault();
                              if (numberValidation(e.target.value))
                                handleChange(e);
                            }}
                            onKeyPress={(e) => {
                              if (e.key == " ") {
                                e.preventDefault();
                              }
                            }}
                            inputProps={{
                              style: {
                                padding: "3px 14px",
                                height: 40,
                              },
                            }}
                            helperText={touched.phone ? errors.phone : ""}
                            error={touched.phone && Boolean(errors.phone)}
                            margin="dense"
                            style={styles.textFieldBg}
                            fullWidth
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{ paddingRight: 4 }}
                            >
                              <InputLabel
                                htmlFor="country"
                                style={styles.labelText}
                              >
                                Country
                              </InputLabel>
                              <ComboSelectBox
                                name="country"
                                id="country"
                                options={countries}
                                onChange={(e) => {
                                  getStateListAll(e.target.value);
                                }}
                                style={{
                                  width: "100%",
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{ paddingLeft: 4 }}
                            >
                              <InputLabel
                                htmlFor="state"
                                style={styles.labelText}
                              >
                                State
                              </InputLabel>
                              <ComboSelectBox
                                name="state"
                                id="state"
                                options={
                                  state.stateName
                                    ? state.stateName
                                    : Object.keys("")
                                }
                                style={{
                                  width: "100%",
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item sm={12}>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{ paddingRight: 4 }}
                            >
                              <InputLabel
                                htmlFor="city"
                                style={styles.labelText}
                              >
                                City
                              </InputLabel>
                              <TextField
                                id="city"
                                name="city"
                                value={values.city}
                                onChange={(e) => {
                                  e.preventDefault();
                                  if (cityValidation(e.target.value))
                                    handleChange(e);
                                }}
                                variant="outlined"
                                inputProps={{
                                  style: {
                                    padding: "3px 14px",
                                    height: 40,
                                  },
                                }}
                                helperText={touched.city ? errors.city : ""}
                                error={touched.city && Boolean(errors.city)}
                                margin="dense"
                                fullWidth
                                style={styles.textFieldBg}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              style={{ paddingLeft: 4 }}
                            >
                              <InputLabel
                                htmlFor="zip"
                                style={styles.labelText}
                              >
                                Zipcode
                              </InputLabel>
                              <TextField
                                id="zip"
                                name="zip"
                                value={values.zip}
                                maxLength="8"
                                onChange={(e) => {
                                  e.preventDefault();
                                  if (zipValidation(e.target.value))
                                    handleChange(e);
                                }}
                                variant="outlined"
                                inputProps={{
                                  style: {
                                    padding: "3px 14px",
                                    height: 40,
                                  },
                                }}
                                helperText={touched.zip ? errors.zip : ""}
                                error={touched.zip && Boolean(errors.zip)}
                                margin="dense"
                                fullWidth
                                style={styles.textFieldBg}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item style={{ marginTop: 24 }}>
                          <SimpleUploadLink
                            onChange={handleFileUpload}
                            labelText="Upload Resume"
                            name="candidate_resume"
                            id="candidate_resume"
                            accept=".doc,.docx,.ppt,.pdf"
                            value={""}
                          />{" "}
                          {state.file
                            ? state.file.map((i) => (
                                <Chip
                                  key={"candidate_resume_chip" + i.name}
                                  size="medium"
                                  label={i.name}
                                  style={styles.chipsStyle}
                                  deleteIcon={
                                    <CancelIcon style={{ color: "#0084BF" }} />
                                  }
                                />
                              ))
                            : null}
                          {state.resumeValidation && !state.file && (
                            <p
                              style={{
                                margin: 0,
                                marginTop: 16,
                                color: "#B53E4E",
                                fontSize: 14,
                              }}
                            >
                              Please upload the resume
                            </p>
                          )}
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            type="submit"
                            style={{
                              width: "auto",
                              height: 40,
                              borderRadius: 4,
                              fontSize: 16,
                              color: "#FFF",
                              background: "#0084bf 0% 0% no-repeat padding-box",
                              fontWeight: "bold",
                              textTransform: "none",
                              marginTop: 24,
                              width: 150,
                            }}
                            onClick={() => {
                              if (!state.file) {
                                setState({ ...state, resumeValidation: true });
                              }
                            }}
                          >
                            Submit
                          </Button>
                        </Grid>
                      </div>
                    </Grid>
                    {isTabletOrLaptopDevice && (
                      <Grid item xs={12} sm={5}>
                        <div style={styles.bgDescription}>
                          <div style={{ padding: "75px 10% 0px" }}>
                            <p style={{ fontSize: 18, fontWeight: "bold" }}>
                              Requisition Details
                            </p>
                            <p>
                              <b>Requisition Number:</b> {qrid}
                            </p>
                            <p>
                              <b>Position Title:</b> {qjt}
                            </p>
                          </div>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </form>
              </>
            )}
          </Formik>
         {/* ) : null} */}
        {/* {isAppliedSuccess && (
          <Card
            style={{
              boxShadow: "0px 2px 1px -1px #fff",
              backgroundColor: isTabletOrLaptopDevice ? "#f4f7fc" : "none",
              height: isTabletOrLaptopDevice ? "100vh" : "100%",
            }}
          >
            <CardContent
              style={{
                padding: isTabletOrLaptopDevice ? "150px 40px" : "25px",
                textAlign: "center",
              }}
            >
              <Typography gutterBottom variant="h5" component="div">
                Thank you for applying!
              </Typography>
              <p>
                We'll review your application and contact you for an interview
                within two weeks if your skills are a match.
              </p>
            </CardContent>
          </Card>
        )} */}
      </Grid>
      {showSnack.type ? <CustomizedSnackbar alertMsg={showSnack} /> : null}
    </Grid>
  );
};

EasyApplyForm.propTypes = {
  resumeValidation: PropTypes.bool,
};

export default EasyApplyForm;
